import React from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const RenderCSVTable = ({ csvData, rowKey = "title" }) => {
  if (!csvData || Object.keys(csvData).length === 0) return null;

  console.log(csvData, "csvMappedData");
  const columns = Object.keys(csvData);
  const rows = Object.values(csvData);
  const rowsLength = csvData[rowKey]?.length;
  console.log(rowsLength, "rowsLength");
  
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((header, index) => (
              <TableCell key={index}>{csvData[header][0]?.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {new Array(rowsLength).fill(1).map((_, index) => {
            return (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {columns.map((column, cellIndex) => (
                  <TableCell key={cellIndex}>
                    {csvData[column][index]?.value}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RenderCSVTable;